/**
 * Shared formatting utilities
 */

export function formatPrice(price: number, currency: string): string {
  // C9 \u2014 show 2 decimals for non-whole amounts so a total visually reconciles
  // with its 2-decimal breakdown lines; keep whole amounts clean (no ".00").
  const amount = Number.isInteger(price) ? String(price) : price.toFixed(2);
  return currency === 'EUR' ? `\u20AC${amount}` : `${amount} ${currency}`;
}
